"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var enums_1 = require("../../../../types/enums");
var WarmHomeActionInput = function () {
    var _a, _b, _c, _d;
    var trans = __2.useSemantics().trans;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var adviceGiven = values.project.warm_home.warm_home_action;
    return (react_1.default.createElement(__1.FormControl, { errors: (_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.warm_home) === null || _b === void 0 ? void 0 : _b.warm_home_action, label: trans('project:slhh::labels.warm-home-action'), showOther: adviceGiven && adviceGiven.indexOf(enums_1.BooleanOther.OTHER) > -1, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.warm_home) === null || _d === void 0 ? void 0 : _d.warm_home_action_other, label: trans('project:slhh::labels.warm-home-action-other') },
            react_1.default.createElement(__1.TextArea, { fast: true, name: "project.warm_home.warm_home_action_other", maxLength: 5000 })) },
        react_1.default.createElement(__1.Select, { options: {
                applied_for_client: trans('project:slhh::enum.warm-home-action.applied_for_client'),
                will_apply: trans('project:slhh::enum.warm-home-action.will_apply'),
                closed_but_interested: trans('project:slhh::enum.warm-home-action.closed_but_interested'),
                advised_reapply_when_open: trans('project:slhh::enum.warm-home-action.advised_reapply_when_open'),
                not_eligible: trans('project:slhh::enum.warm-home-action.not_eligible'),
                already_receiving: trans('project:slhh::enum.warm-home-action.already_receiving'),
                other: trans('project:slhh::enum.warm-home-action.other'),
            }, name: "project.warm_home.warm_home_action" })));
};
exports.default = WarmHomeActionInput;
//# sourceMappingURL=WarmHomeActionInput.js.map